import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
  axiosPatchWithCookies,
} from './helper';

export const getAssetList = ({
  securityCompanyId,
  archived,
  category,
  type,
  search,
  from,
  status,
  departmentId,
}) => {
  let query = `/assets/assets?securityCompanyId=${securityCompanyId}&includeArchived=${archived}&limit=50`;
  if (status && Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, s) => `${acc}&status=${s.id}`, '');
  }
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (category && category !== 'ALL') {
    /* eslint-disable no-param-reassign */
    query += Array.isArray(category)
      ? category.reduce((acc, s) => `${acc}&category=${s}`, '')
      : `&category=${category}`;
  }
  if (type) query += `&assetType=${type}`;
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;

  return axiosGetWithCookies(query);
};
//fetch asset detail
export const fetchAssetDetail = ({ id, filters }) => {
  let query = `/assets/assets/${id}`;
  if (filters) {
    const { dateFrom, dateTo } = filters;
    if (dateFrom) {
      query += `?fromDate=${dateFrom}`;
      if (dateTo) query += `&toDate=${dateTo}`;
    }
  }
  return axiosGetWithCookies(query);
};

export const fetchAssetByCategory = (securityCompanyId, assetId, category) =>
  axiosGetWithCookies(
    `/assets/assets?securityCompanyId=${securityCompanyId}&category=${category}&assetType=${assetId}&limit=50`,
  );
//add new asset
export const addAsset = asset =>
  axiosPostWithCookies(`/assets/assets`, {
    data: asset,
  });
export const updateAsset = (id, asset) =>
  axiosPutWithCookies(`/assets/assets/${id}`, { data: asset });
export const generateOtp = id =>
  axiosPutWithCookies(`/assets/assets/phones/${id}/otp`);
//assign asset by handover
export const assetHandover = ({ id, giver, receiver, state }) =>
  axiosPatchWithCookies(`/assets/assets/${id}/handover`, {
    data: {
      giver: giver,
      receiver: receiver,
      state: state,
    },
  });
//make asset available
export const makeStatusAvailable = id =>
  axiosPatchWithCookies(`/assets/assets/${id}/available`);
//make asset Unavailable
export const makeStatusUnavailable = id =>
  axiosPatchWithCookies(`/assets/assets/${id}/unavailable`);
export const requestAssetReturn = ({ assetAssigneeId, id, assetId, name }) =>
  axiosPostWithCookies(`/assets/assets/request-return/${assetAssigneeId}`, {
    data: {
      id: id,
      assetId: assetId,
      name: name,
    },
  });
export const updateAssetPasscode = (id, passcode) =>
  axiosPatchWithCookies(`/assets/assets/${id}/passcode`, {
    data: passcode,
  });
